// MARK: React
import * as React from "react";

// MARK: Mobx
import { observer, inject } from "mobx-react";

// MARK: Router
import { Route, Switch } from "react-router-dom";

// MARK: Stores
import AuthStore from "../../../stores/AuthStore";

// MARK: Pages
import UsersTable from "./UsersTable";
import UserDetails from "./UserDetails";
import EditUser from "./EditUser";

interface IProps extends IStores {}
interface IStores {
	authStore: AuthStore;
}

@inject("authStore")
@observer
export default class Users extends React.Component<IProps> {
	public static defaultProps: IStores;

	public render() {
		return (
			<Switch>
				<Route exact={true} path="/dashboard/users" component={UsersTable} />
				<Route path="/dashboard/users/editor/:userId" component={EditUser} />
				<Route path="/dashboard/users/:userId" component={UserDetails} />
			</Switch>
		);
	}
}
